<script>
/** Utilities */
import {mapState,mapMutations} from 'vuex'
import BrowserDataUtil from '../../utilities/BrowserDataUtil'
import AppResourceUtil from '../../utilities/AppResourceUtil'
/** APIs */
import UserApi from '../../api/UserApi'
import IssueApi from '../../api/IssueApi'
/** UI Components */
import { Collapse } from 'buefy/dist/components/collapse'
import { Dropdown, DropdownItem } from 'buefy/dist/components/dropdown'
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Loading } from 'buefy/dist/components/loading'
import { Modal } from 'buefy/dist/components/modal'
import { Table,TableColumn } from 'buefy/dist/components/table'
import { Switch } from 'buefy/dist/components/switch'

export default {
    name : "IssuesView",
    components: {
        'b-collapse' : Collapse,
		'b-dropdown' : Dropdown,
        'b-dropdown-item' : DropdownItem,		
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-loading' : Loading,
        'b-modal' : Modal,
        'b-table' : Table,
        'b-table-column' : TableColumn,
        'b-switch' : Switch
    },
    computed : {
        ...mapState({
            profile : "userProfile",
            token : "xOreAuth"
        }),
        filteredIssues(){
            if (this.showResolved==true) {
                if (this.allIssues.length > 0) {
                    return this.allIssues.filter(issue=>{
                        return (issue.issueStatus=='Resolved');
                    });
                }
            }
            return this.allIssues.filter(issue=>{
                return (issue.issueStatus===this.activeStatus);
            });
        },
        resetItems(){
            if (this.allIssues.length > 0) {
                return this.allIssues.filter(issue=>{
                    return (issue.issueType=='Support' && 
                            issue.issueStatus=='Pending' &&
                            issue.htmlMessage=='Reset Password');
                });
            }
            return [];
        }
    },
    data(){
        return {
            allIssues : [],
            tableCheckboxPosition : "left",
            tableCheckedRows : [],
            isFullPage : false, 
            isLoading : false,
            showResolved : false,
            activeStatus: 'Pending'
        }
    },
    created(){
        if (!this.profile) {
            this.clearSession();
            return false;
        }
        this.isTokenValid();
        this.$eventHub.$emit('issues-updated',true);
    },
    methods: {
        ...mapMutations({
            clearAppData : "clearAppData", 
            setProfile : "updateUserProfile"
        }),
        isTokenValid(){
            if (!this.token) {
                this.clearSession();
                return false
            }
            UserApi.isTokenValid({
                token : this.token
            })
            .then(response=>{
                if (response.data){
                    if (response.data.length > 0) {
                        let data = response.data[0];
                        if (data.dateCreated) {
                            let a = this.$moment();
                            let b = this.$moment(data.dateCreated,'YYYY-MM-DD HH:mm:ss');
                            let duration = a.diff(b, 'days');
                            if (duration >= 1 ) {
                                // Session is expired
                                this.logOut()
                            }
                            else {
                                // Session is still active
                                // Default call in created
                                this.getIssues();
                            }
                        }
                    }
                    else {
                        if (response.data.hasOwnProperty('error')) {
                            this.promptServerError({response},'User.isSessionValid');
                            return false;
                        }
                        this.logOut();
                        return false;
                    }
                } 
            })
            .catch(error=>{
                this.promptServerError(error,'User.isSessionValid');
            });
        },
        logOut(){   
            if (this.token) {
                let data = {
                    token : this.token
                }
                if (this.profile) {
                    data.userIdFk = this.profile.userId
                }
                // End session from back-end
                UserApi.endSession(data)
                .then(response=>{
                    if (response.data) {
                        if (response.data.isDeleted) {
                            this.clearSession();
                        }
                    }
                })
                .catch(error=>{
                })
            }
            else {
                // Remove session data from client-side
                this.clearSession();
            }
        },
        clearSession(){
            BrowserDataUtil.clearBrowserData(this.$cookies);
            this.clearAppData();
            this.$router.push({path:"/login"})
        },
        getIssues(){
            this.isLoading = true;
            this.allIssues = [];
            IssueApi.get()
            .then(response=>{
                let issues = response.data;
                if (response.data) {
                    if (!response.data.error) {
                        if (issues.length > 0) {
                            issues.forEach(issue=>{
                                if (issue.message) {
                                    issue.htmlMessage = issue.message.replace(/(?:\r\n|\r|\n)/g, '<br />');
                                }
                                /** Convert date */
                                issue.dateCreated = AppResourceUtil.convertDate(issue.dateCreated)
                                issue.dateResolved = AppResourceUtil.convertDate(issue.dateResolved)
                            })
                        }
                        this.allIssues = issues;
                        this.isLoading = false;
                    }
                    else {
                        this.isLoading = false;
                        this.promptServerError({response},'Issue.get');
                    }
                }
            })
            .catch(error=>{
                this.isLoading = false;
                this.promptServerError(error,'Issue.get');
            });
        },
        confirmReset(){
            this.$dialog.confirm({
                title: 'Confirmation',
                message: 'This action will process all \'Reset Password\' requests and will reset the passwords accordingly. What do you want to do?',
                cancelText: "Cancel",
                confirmText: 'Proceed and Reset',
                type: 'is-success',
                onConfirm: () => {
                    this.doResetAll();
                }
            })
        },
        doResetAll(){
            let emailForReset = this.resetItems.map(i=>{
                return i.email;
            });
            
            UserApi.bulkResetPwdEmail({
                emails : emailForReset,
                updatedBy : this.profile.userId
            })
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.passwordReset) {
                            this.$dialog.alert({
                                title: 'Success',
                                message: "<p>Password are now reset to default. You may notify the users through their email address to log in and use the default password.</p>",
                                type: 'is-success'
                            });
                            this.autoResolve();
                        }
                    }
                    else {
                        this.promptServerError({response},'UserApi.bulkResetPwdEmail');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'UserApi.bulkResetPwdEmail');
            });
        },
        autoResolve(){
            let ids = this.resetItems.map(i=>{
                return i.issueId;
            });
            if (ids.length > 0) {
                IssueApi.bulkUpdate({
                    issueStatus : 'Resolved',
                    issueIds : ids,
                    userIdFk : this.profile.userId
                })
                .then(response=>{
                    if (response.data) {
                        if (!response.data.error) {
                            if (response.data.isUpdated) {
                                this.$notification.open({
                                    duration: 5000,
                                    message: 'Issue updated.',
                                    position: 'is-bottom-left',
                                    type: 'is-success'
                                });
                                this.$eventHub.$emit('issues-updated',true);
                            }
                            this.getIssues();
                        }
                        else {
                            this.promptServerError({response},'Issue.update');
                        }
                    }
                })
                .catch(error=>{
                    this.promptServerError(error,'Issue.update');
                });
            }
        },
        confirmDeleteIssue(issue){
            if (!issue && this.tableCheckedRows.length==0) {
                return false;
            }
            // Confirm Action
            this.$dialog.confirm({
                title: 'Confirmation',
                message: 'This action will delete selected issue/s from the database. What do you want to do?',
                cancelText: "Don't Delete",
                confirmText: 'Delete',
                type: 'is-danger',
                onConfirm: () => {
                    this.deleteIssue(issue)
                }
            })
        },
        deleteIssue(issue) {
            let ids = [];
            if (issue==null) {
                if (this.tableCheckedRows.length > 0) {
                    ids = this.tableCheckedRows.map(row=>{
                        return row.issueId;
                    });
                }
            }
            else {
                ids.push(issue.issueId);
            }

            if (ids.length==0){
                this.$dialog.alert({
                    title: 'Error',
                    message: "<p>Unable to proceed. No data selected.</p>",
                    type: 'is-error'
                });
                return false;
            }

            IssueApi.delete(ids)
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.isDeleted) {
                            this.$notification.open({
                                duration: 5000,
                                message: 'Issue/s deleted.',
                                position: 'is-bottom-left',
                                type: 'is-success'
                            });
                            this.$eventHub.$emit('issues-updated',true);
                            this.getIssues();
                        }
                    }
                    else {
                        this.promptServerError({response},'Issue.delete');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.delete');
            });
        },
        resolve(issue) {
            if (!issue) {
                return false;
            }
            if (issue) {
                IssueApi.update({
                    issueStatus : 'Resolved',
                    issueId : issue.issueId,
                    userIdFk : this.profile.userId
                })
                .then(response=>{
                    if (response.data) {
                        if (!response.data.error) {
                            if (response.data.isUpdated) {
                                this.$notification.open({
                                    duration: 5000,
                                    message: 'Issue updated.',
                                    position: 'is-bottom-left',
                                    type: 'is-success'
                                });
                                this.$eventHub.$emit('issues-updated',true);
                                this.getIssues();
                            }
                        }
                        else {
                            this.promptServerError({response},'Issue.update');
                        }
                    }
                })
                .catch(error=>{
                    this.promptServerError(error,'Issue.update');
                });
            }
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        },
        filterIssues(status) {
            this.activeStatus = status
        }
    }
}
</script>

<template>
    <section>
        <p class="subtitle page-title">Feedback & Issues</p>
        
        <section class="section no-padd--top"> 

            <section class="base-box--loading"
                v-if="isLoading">
                <b-loading 
                    v-bind:is-full-page="isFullPage" 
                    v-bind:active.sync="isLoading"
                    >
                    <b-icon
                        pack="fas"
                        icon="sync-alt"
                        size="is-medium"
                        custom-class="fa-spin">
                    </b-icon>
                    &nbsp;&nbsp;&nbsp;
                    <span class="title is-5">Loading data</span>
                </b-loading>
            </section>

            <section
                v-if="!isLoading"
                style="padding-bottom:0.6rem;vertical-align:middle">

                <b-field grouped group-multiline>
                    <!-- <div class="field">
                        <span>
                            Total seleted: {{tableCheckedRows.length}}
                        </span>
                    </div> -->
                
                    <button class="button field"
                        v-on:click="tableCheckedRows = []"
                        v-bind:disabled="tableCheckedRows.length==0">
                        <!-- <b-icon icon="close"></b-icon> -->
                        <span>Clear selected</span>
                    </button>
                    
                    <button class="button field is-danger is-outlined"
                        v-on:click="confirmDeleteIssue(null)"
                        v-bind:disabled="tableCheckedRows.length==0">
                        <!-- <b-icon icon="delete"></b-icon> -->
                        <span>Delete</span>
                    </button>

                    <button 
                        class="button field is-success"
                        v-if="resetItems.length > 0"
                        v-on:click="confirmReset">
                        <span>Process All 'Reset Password' Issues</span>
                    </button>

                    <button class="button field is-light tooltip is-tooltip-top"
                        data-tooltip="Refresh data"
                        v-on:click="getIssues">
                        <span class="icon">
                            <i class="fas fa-redo"></i>
                        </span>
                    </button>

                    <div class="buttons has-addons"
                        style="border:none;border-left:1px solid #e5e5e5;padding-left:0.75rem">
                        <button 
                            class="button"
                            :class="{'is-info':activeStatus=='Pending'}"
                            :disabled="showResolved"
                            @click="filterIssues('Pending')">Issue</button>
                        <button 
                            class="button"
                            :class="{'is-info':activeStatus=='Not Applicable'}"
                            :disabled="showResolved"
                            @click="filterIssues('Not Applicable')">Feedback</button>
                    </div>

                    <b-field
                        style="margin-left:0.5rem;margin-top:0.3rem;">
                        <b-switch v-model="showResolved"
                            type="is-success">
                            Show Resolved Only
                        </b-switch>
                    </b-field>

                </b-field>

            </section>
            
            <section class="section no-padd app-view">

                <div
                    v-if="!isLoading">

                    <!-- table here -->
                    <b-table
                        v-bind:striped="true"
                        v-bind:mobile-cards="true"
                        v-bind:data="filteredIssues"
                        v-bind:checked-rows.sync="tableCheckedRows"
                        checkable
                        v-bind:checkbox-position="tableCheckboxPosition">

                        <template
                            slot-scope="props">

                            <!-- <b-table-column
                                field="issueId"
                                label="ID"
                                width="25">
                                {{props.row.issueId}}
                            </b-table-column> -->

                            <b-table-column
                                field="issueType"
                                label="Issue Type"
                                width="75">
                                {{props.row.issueType}}
                            </b-table-column>

                            <b-table-column
                                field="message"
                                label="Description"
                                width="120">
                                <div v-html="props.row.htmlMessage"></div>
                            </b-table-column>

                            <b-table-column
                                field="email"
                                label="Email"
                                width="50">
                                {{props.row.email}}
                            </b-table-column>

                            <b-table-column
                                field="username"
                                label="Username"
                                width="50">
                                {{props.row.username}}
                            </b-table-column>

                            <b-table-column
                                field="issueStatus"
                                label="Status"
                                width="75">
                                <span
                                    v-bind:class="props.row.issueStatus=='Resolved' ? 'has-text-success' : 'has-text-grey'">
                                    {{props.row.issueStatus}}
                                </span>
                            </b-table-column>

                            <b-table-column
                                field="pageName"
                                label="Page"
                                width="75">
                                {{props.row.pageName}}
                            </b-table-column>

                            <!-- <b-table-column
                                field="createdByName"
                                label="Created By"
                                width="100">
                                {{props.row.createdByName}}
                            </b-table-column> -->

                            <b-table-column
                                field=""
                                label="Actions"
                                width="100">
                                <button class="button is-danger is-outlined tooltip is-tooltip-top"
                                    data-tooltip="Delete"
                                    type="button"
                                    v-on:click="confirmDeleteIssue(props.row)">
                                    <span class="icon">
                                        <i class="fas fa-trash"></i>
                                    </span>
                                </button>&nbsp;
                                <button class="button is-success tooltip is-tooltip-top"
                                    data-tooltip="Resolved"
                                    type="button"
                                    v-on:click="resolve(props.row)"
                                    v-if="props.row.issueStatus=='Pending'">
                                    <span class="icon">
                                        <i class="fas fa-check"></i>
                                    </span>
                                </button>
                            </b-table-column>

                            <b-table-column
                                label="Logs"
                                width="50"
                                centered>
                                <b-dropdown 
                                    aria-role="list" 
                                    position="is-bottom-left">
                                    <button type="button"
                                        class="button is-small is-light"
                                        slot="trigger"
                                        role="button">
                                        <span class="icon fa-sm">
                                            <i class="fas fa-ellipsis-h fa-lg"></i>
                                        </span>
                                    </button>
                                    <b-dropdown-item aria-role="listitem">
                                        <div v-if="props.row.issueStatus=='Resolved'">
                                            <strong>Resolved by: </strong> {{props.row.resolvedByName}}<br/>
                                            <strong>Date resolved: </strong> {{props.row.dateResolved}}
                                        </div>
                                        <hr class="dropdown-divider" v-if="props.row.issueStatus=='Resolved'">
                                        <div>
                                            <strong>Created by: </strong> {{props.row.createdByName}}<br/>
                                            <strong>Date created: </strong> {{props.row.dateCreated}}
                                        </div>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </b-table-column>

                        </template>

                        <template slot="empty">
                            <section class="section">
                                <div class="content has-text-grey has-text-centered">
                                    <p>No issues reported.</p>
                                </div>
                            </section>
                        </template>
                    </b-table>
                </div>  
                
            </section>
            
        </section>  

        
    </section>
</template>

<style scoped>
.collapse-header {
    background-color: whitesmoke;
}
</style>




// WEBPACK FOOTER //
// src/views/administration/IssuesView.vue